import React from 'react'
import '../../styles.css'
import letterToAnimalimg from '../../assets/howTo/letterToAnimal.png'
import animalToLetterimg from '../../assets/howTo/animalToLetter.png'
import audioToLetterimg from '../../assets/howTo/audioToLetter.png'
import audioToAnimalimg from '../../assets/howTo/audioToAnimal.png'
import letterTypeimg from '../../assets/howTo/typeAnswer.png'

const howToPlayImages = {
    1: letterToAnimalimg,
    2: animalToLetterimg,
    3: audioToLetterimg,
    4: audioToAnimalimg,
    5: letterTypeimg
}

const howToPlayDescriptions = {
    1: 'You will hear the sound of the letter shown. Select the animal or object that starts with that letter.',
    2: 'You will hear the sound of the first letter of the name of the animal or object shown. Select the starting letter of the name of the animal or object.',
    3: 'You will hear the sound of a letter. You must select the correct letter you hear.',
    4: 'You will hear the sound of a letter. You must select the correct animal or object that starts with the letter you hear.',
    5: 'You will hear the sound of a letter. You must type the correct letter you hear.'
}

function Tutorial(props) {
    return (
        <div className='row'>
            <div>
                <img src={howToPlayImages[props.levelType]} style={{width: '70%', height: '70%'}} alt='Object' />
            </div>
            <b className='introSentence' style={{wordWrap: 'break-word', width: 500}}>{howToPlayDescriptions[props.levelType]}</b>
        </div>
    )

    // <button className='rightButton'><img className='imagesInDivs' src={audioimg} alt="AUDIO" onClick={handleAudio}/></button>

    // function handleAudio() {
    //     audio.play();
    // }
}

export default Tutorial
